<section class="ftco-section  bg-light" *ngIf="propertyList.length > 0">
    <div class="container-xl">
        <div class="row justify-content-center">
            <div class="col-md-8 heading-section text-center mb-5" data-aos="fade-up" data-aos-duration="1000">
                <h2 class="mb-4">
                    Featured Properties
                </h2>
            </div>
        </div>
        <div class="row">
            <ng-container *ngFor="let propertyData of propertyList">
                <div class="col-md-3" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                    <app-common-featured-property [propertyData]='propertyData'></app-common-featured-property>
                </div>

            </ng-container>
        </div>
    </div>
</section>